function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M42.73 17.7c.65.26 1.2.81 1.46 1.52a21.83 21.83 0 01-19.35 28.75 21.47 21.47 0 01-16.07-5.91A21.51 21.51 0 012 26.34c0-5.8 2.22-11.26 6.32-15.36a21.42 21.42 0 0115.15-6.36V1.49C23.47.32 24.8-.38 25.8.22l8.94 5.5c.96.62.96 1.98 0 2.59l-8.9 5.55a1.5 1.5 0 01-2.32-1.26V9.52h-.96a16.8 16.8 0 102.89 33.45A17 17 0 0040.4 28.42c.3-2.63.05-5.2-.8-7.63a2.45 2.45 0 011.05-2.88 2.3 2.3 0 012.08-.2zm-21.18.46l2.99 7.98H32a2.43 2.43 0 010 4.85h-9.2a2.4 2.4 0 01-2.27-1.56l-3.53-9.55a2.43 2.43 0 114.54-1.72z",
  clipRule: "evenodd"
})));